module.exports = __webpack_public_path__ + "static/media/signout.3ca5de31.svg";